import { getLocationType, LOCATION_TYPES, } from '../calculated/get-location-type';
import { get } from '../../../utils/get';
import { getOnlineConfAvailable } from '../calculated/get-online-conf-available';
import { getEventUrl } from '../calculated/get-event-url';
export var getLocation = function (item) {
    if (!item.event) {
        return '';
    }
    var locationType = getLocationType(item);
    var name = get(item, 'event.location.name');
    var address = get(item, 'event.location.address');
    var url = getEventUrl(item);
    var hasOnlineAvailability = getOnlineConfAvailable(item);
    var location = {
        '@type': locationType,
    };
    if (name) {
        location.name = name;
    }
    if (locationType === LOCATION_TYPES.PHYSICAL) {
        location.address = address;
    }
    if (hasOnlineAvailability) {
        location.url = url;
    }
    return location;
};
